var exports = {
  "R": "FocusRing.module__focusRing___Zm5laz",
};

module.exports = exports;
